// extracted by mini-css-extract-plugin
export default {"placeholder":"placeholder-loader_placeholder__6GrJv","pulse":"placeholder-loader_pulse__2O3dr","dark_placeholder":"placeholder-loader_dark_placeholder__CAgSI"};